import { Alert, Container, Pagination, Snackbar, Stack } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { listAllUsers } from '../../api/api-middleware';
import AddUser from '../../components/users/AddUser';
import ListTable from '../../components/users/ListTable';
import useAuthToken from '../../hooks/getUserData';
import DashboardLayout from '../../layout/dashboard/DashboardLayout';
import { userFields } from '../../staticData/tableHead';

const Users = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const usertype = queryParams.get('usertype');

  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(0);
  const pageSize = 15;
  const [totalPages, setTotalPages] = useState(0);
  const token = useAuthToken();
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [userType, setUserType] = useState(usertype || 'all')
  const [filterName, setFilterName] = useState('')

  const fetchData = async (pageNumber) => {
    try {
      if (token) {
        setLoading(true);
        const pageToFetch = pageNumber !== undefined ? pageNumber : page;
        const response = await listAllUsers(pageToFetch, pageSize, token, filterName, userType === 'all' ? '' : userType);
        if (!response.ok) {
          throw new Error('Failed to fetch data');
        }

        const data = await response.json();
        setItems(data?.users);
        setError(null);

        setTotalPages(Math.ceil(data?.count / pageSize));
      }
    } catch (error) {
      setError(error.message || 'An error occurred while fetching users');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (token) {
      fetchData(0);
      setPage(0);
      navigate(`/users?usertype=${userType}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userType, token, filterName]);

  const handlePageChange = (newPage) => {
    setPage(newPage);
    fetchData(newPage + 1);
  };

  const handleUserTypeChange = (event) => {
    setUserType(event.target.value);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  return (
    <DashboardLayout>
      <Container maxWidth="xl">
        <Stack spacing={2}>
            <>
              {error ? (
                <Alert severity="error" onClose={() => setError(null)}>
                  {error}
                </Alert>
              ) : (
                <>
                  <Snackbar
                   anchorOrigin={{ vertical: "bottom", horizontal: 'center' }}
                    open={snackbarOpen}
                    autoHideDuration={3000} 
                    onClose={() => setSnackbarOpen(false)}>
                    <Alert severity="success" sx={{ width: '100%' }}>
                      {snackbarMessage}
                    </Alert>
                  </Snackbar>

                  <ListTable
                    filteredData={items}
                    setItems={setItems}
                    fetchData={fetchData}
                    columnFields={userFields}
                    tableName={'Users'}
                    loading={loading}
                    addModal={
                      <AddUser fetchData={fetchData} setMessage={setSnackbarMessage} setSnackbarOpen={setSnackbarOpen}/>
                    }
                    handlePageChange={handlePageChange}
                    page={page}
                    pageSize={pageSize}
                    setError={setError}
                    setPage={setPage}
                    setMessage={setSnackbarMessage} setSnackbarOpen={setSnackbarOpen}
                    handleUserTypeChange={handleUserTypeChange}
                    userType={userType}
                    setUserType={setUserType}
                    handleFilterByName={handleFilterByName}
                    filterName={filterName}
                  />
                  {totalPages > 1 && (
                     <Pagination
                     count={totalPages}
                     page={page + 1}
                     onChange={(event, newPage) => handlePageChange(newPage - 1)}
                     sx={{ alignSelf: 'center' }}
                   />
                  )}
                </>
              )}
            </>
        </Stack>
      </Container>
    </DashboardLayout>
  );
};

export default Users;
